export enum PromotionItemRuleType {
    PurchaseItemRules = "PurchaseItemRules",
    DiscountItemRules = "DiscountItemRules",
}
